module.exports = __webpack_public_path__ + "img/menuLeft.291e8e03.png";